export const adminListConnections = `query adminListConnections {
  adminListConnections{
    connectionId
    name
    type
    description
    active
    databases {
      name
      label
    }
  }
}`;

export const adminGetConnection = `query adminGetConnection($connectionId: ID!) {
  adminGetConnection(connectionId: $connectionId){
    connectionId
    name
    type
    description
    active
    databases {
      name
      label
      parameters
    }
    settings {
      host
      port
      database
      username
      password
      isSSH
      sshHost
      sshPort
      sshUsername
    }
    parameters
  }
}`;
